import { render, staticRenderFns } from "./monthstockmore.vue?vue&type=template&id=0dc33619&scoped=true&"
import script from "./monthstockmore.vue?vue&type=script&lang=js&"
export * from "./monthstockmore.vue?vue&type=script&lang=js&"
import style0 from "./monthstockmore.vue?vue&type=style&index=0&id=0dc33619&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc33619",
  null
  
)

export default component.exports